<script setup>

import { defineProps, defineEmits} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "followUp",
    "controlesDesativoados"
]);

const emits = defineEmits([
    "update:followUp"
]);

//==================================================================//
//==================== Altera Data de Entrega ======================//
//==================================================================//

const alteraDataEntrega = (dataEntrega) =>{

    emits('update:followUp',{
        dataEntrega: dataEntrega
    });

}

//==================================================================//
//====================== Altera Observação =========================//
//==================================================================//

const alteraObservacao = (observacao) =>{

    emits('update:followUp',{
        observacao: observacao
    });

}

</script>

<template>

  <v-card
        class="c-novo-followup"
    >

        <v-card-title
            class="c-novo-followup__titulo"
        >
        
            <h3>Novo FollowUp</h3>

        </v-card-title>

        <div
            class="c-novo-followup__conteudo"
        >

            <v-text-field
                class="c-campo c-campo__dataEntrega"
                :value="props?.followUp?.dataEntrega"
                label="Data de Entrega"
                outlined
                type="date"
                hide-spin-buttons
                required
                :disabled="props.controlesDesativados"
                @input="alteraDataEntrega"
            ></v-text-field>

            <v-textarea
                :value="props?.followUp?.observacao"
                class="c-campo"
                label="Observação"
                variant="outlined"
                no-resize
                outlined
                auto-grow
                :disabled="props.controlesDesativados"
                @input="alteraObservacao"
            >
            </v-textarea>

        </div>

    </v-card>

</template>

<style scoped>

.c-campo__dataEntrega{
    justify-self: flex-start;
}

</style>